<template>
    <div>
        <v-toolbar dark color="orange" dense flat>
            Padecimiento CIE-10
            <v-spacer/>
            <v-btn icon @click="dialogCatCie=true"><v-icon>mdi-plus</v-icon></v-btn>
            <v-btn icon @click="listCie10()"><v-icon>mdi-sync</v-icon></v-btn>
        </v-toolbar>
        <v-snackbar color="green"
            v-model="snackbarAgrega"
            :timeout="3000"
        >
            Guardado
        </v-snackbar>

        <v-snackbar color="red"
            v-model="snackbarBorra"
            :timeout="3000"
        >
            Borrado
        </v-snackbar>

        <list-cie10
            :dialogCatCie.sync='dialogCatCie'
            :listaPadecimienos.sync='listaPadecimienos'
            :esteDiagId.sync='padPadecimiento'
        />

        <v-data-table
            elevation="2"
            :headers="headers"
            :items="itemsPadecimientos"
            disable-sort
            item-key="id"
            :loading="loadingCarga"
            class="elevation-1"
            hide-default-footer
        >

            <template v-slot:[`item.acciones`]="{ item }">
                <v-btn icon @click="borra(item.id)">
                    <v-icon color="red">mdi-cancel</v-icon>
                </v-btn>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    mounted(){
        this.listCie10()
        //console.log(this.diag)
    },

    props:{
        diag:Number
    },

    components:{
        'list-cie10':()=>import('@/components/diagnosticos/catalogoDiagnostico'),
    },
    data:()=>({
        itemsPadecimientos:[],
        dialogCatCie:false,
        listaPadecimienos:[],
        padPadecimiento:0,
        loadingNuevo:false,
        loadingCarga:false,
        headers:[
            { text: 'Clave', value: 'clave', width:'10%'},
            { text: 'Diagnóstico', value: 'diag'},
            { text: '', value: 'acciones', width:'10%'},
        ],

        snackbarAgrega:false,
        snackbarBorra:false,
    }),

    methods:{

        async borra2(id){
            try{
                const req = await this.$http({
                    url:'/insabi/borra',
                    method:'POST',
                    params:{
                        diag:this.diag,
                        pad:id
                    }
                })
                if (req.data.estado){
                    this.snackbarBorra = true
                    this.listCie10()
                }
            }catch(err){
                this.$store.dispatch('security/revisaError',err)
            }
        },

        borra(id){
            this.$swal.fire({
                title:'¿Desea borrar?',
                text:'Esta acción no se puede deshacer',
                icon: 'warning',
                showCancelButton: true,

                confirmButtonText:'Borrar',
                cancelButtonText:'No borrar',

                confirmButtonColor: 'red',
                cancelButtonColor: 'blue',
            }).then((result)=>{
                if (result.value){
                    this.borra2(id)
                }
            })
        },
        async listCie10(){
            this.itemsPadecimientos=[]
            this.loadingCarga=true
            try{
                const req = await this.$http({
                    url:'/insabi/listCie10',
                    method:'POST',
                    params:{
                        diag:this.diag,
                    }
                })
                this.loadingCarga=false
                this.itemsPadecimientos=req.data
            }catch(err){
                this.loadingCarga=false
                this.$store.dispatch('security/revisaError',err)
            }
        },
        async guardaCie10(){
            try{
                const req = await this.$http({
                    url:'/insabi/guardaCie10',
                    method:'POST',
                    params:{
                        diag:this.diag,
                        pad:this.padPadecimiento
                    }
                })
                if (req.data.estado){
                    this.snackbarAgrega = true
                    this.listCie10()
                }
            }catch(err){
                this.$store.dispatch('security/revisaError',err)
            }
        }
    },

    watch:{
        diag(){
            this.listCie10()
            //console.log(v)
        },
        padPadecimiento(v){
            if(v){
                this.guardaCie10()
            }
        }
    }

}
</script>

<style>

</style>